export default __webpack_public_path__ + "static/Cyber-Security-0ac6017903007db6d05937dd03b3b104.png";